import Vue, {
  KeepAlive
} from 'vue';
import VueRouter from 'vue-router';

import Cookies from 'js-cookie';
import Header from '@/view/header/Header.vue';
import {
  setStore,
  getStore,
  removeStore
} from '@/utils/storage';
import {
  getUserByTicket
} from '@/api/sso.js';
import {
  login,
  userInfo,
  getBoroughs
} from '@/api/index';
import axios from 'axios';
import AES from '@/utils/AES';

Vue.use(VueRouter);

const router = new VueRouter({
  // 配置路由；
  mode: 'hash',
  base: '/TPWeb/',
  //打包配置
  routes: [{
      path: '/locking',
      name: 'locking',
      component: () => import('../view/header/lockscreen/components/locking-page.vue'),
    },
    {
      path: '/resourceCensor',
      name: 'resourceCensor',
      component: () => import('@/view/resourceCensor/index.vue'),
    },
    {
      path: '/CensusProgress',
      name: 'CensusProgress',
      component: () => import('@/view/CensusProgress/index.vue'),
    },
    {
      path: '/pdfpreview',
      name: 'pdfpreview',
      component: () => import('@/view/censusProduct/pdfpreview.vue')
    }, //pdf预览
    {
      path: '/',
      redirect: {
        name: 'Homepage',
      },
      component: Header,
      children: [{
          path: '/VideoPages/:index',
          name: 'VideoPages',
          component: () => import('@/view/homepage/VideoPages.vue'),
        },
        {
          path: '/',
          // name: 'Homepage',
          // component: () => import('@/view/homepage/Homepage.vue'),
          // meta: {
          //   requireAuth: true,
          // },
          name: 'geologicalData',
          component: () => import('@/view/geologicalData/index.vue'),
          meta: {
            KeepAlive: true,
          }
        }, //设置当为空的时候，自动跳转到登录页面； 公用不同的头部的时候
        {
          path: '/ResourceDetails',
          name: 'ResourceDetails',
          component: () => import('@/view/homepage/routerComponents/ResourceDetails.vue'),
        },
        {
          path: '/functionalService',
          redirect: {
            name: 'functionalService',
          },
          component: () => import('@/view/FunctionalService/FunctionalService.vue'),
          children: [{
              path: '/businessApplicationHome',
              name: 'businessApplicationHome',
              component: () =>
                import('@/view/FunctionalService/components/businessApplicationHome.vue'),
            }, //功能服务
          ],
        },
        {
          path: '/geologicalData',
          name: 'geologicalData',
          component: () => import('@/view/geologicalData/index.vue'),
          meta: {
            KeepAlive: true,
          }
        }, //地质数据
        {
          path: '/geologicalDataInfo/:id',
          name: 'geologicalDataInfo',
          component: () => import('@/view/geologicalData/geologicalDataInfo.vue'),
        },
        {
          path: '/oneMap',
          name: 'oneMap',
          component: () => import('@/view/oneMap/index.vue'),
        },
        {
          path: '/censusProduct',
          name: 'censusProduct',
          component: () => import('@/view/censusProducts/censusProduct.vue'),
        }, //普查产品
        {
          path: '/censusProductDetails',
          name: 'censusProductDetails',
          component: () => import('@/view/censusProduct/components/censusProductDetails.vue'),
        }, //普查产品详情
        {
          path: '/ThreeDimensionalReality',
          name: 'threeDimensionalReality',
          component: () => import('@/view/ThreeDimensionalReality/threeDimensionalReality.vue'),
        }, //三维实景
        {
          path: '/policyPaper',
          name: 'policyPaper',
          component: () => import('@/view/censusActivity/policyPaper.vue'),
        }, //普查动态-政策文件
        {
          path: '/newsInformation',
          name: 'newsInformation',
          component: () => import('@/view/censusActivity/newsInformation.vue'),
        },
        {
          path: '/notice',
          name: 'notice',
          component: () => import('@/view/censusActivity/notice.vue'),
        }, //普查动态-通知公告
        {
          path: '/trainingCourse',
          name: 'trainingCourse',
          component: () => import('@/view/censusActivity/trainingCourse.vue'),
        }, //普查动态-培训学习
        {
          path: '/forumCommunity',
          name: 'forumCommunity',
          component: () => import('@/view/forumCommunity/forumCommunity.vue'),
        },
        {
          path: '/ResourceDiscovery',
          name: 'ResourceDiscovery',
          component: () => import('@/view/ResourceDiscovery/index.vue'),
        },
        {
          path: '/PublishArticle',
          name: 'PublishArticle',
          component: () => import('@/view/ResourceDiscovery/MarkerDown/index.vue'),
        },
        {
          path: '/commentCount',
          name: 'commentCount',
          component: () =>
            import('@/view/ResourceDiscovery/Right/components/components/commentCount.vue'),
        },
        {
          path: '/releaseCount',
          name: 'releaseCount',
          component: () =>
            import('@/view/ResourceDiscovery/Right/components/components/releaseCount.vue'),
        },

        {
          path: '/postCreate',
          name: 'postCreate',
          component: () => import('@/view/forumCommunity/post/Create.vue'),
        },
        {
          path: '/postEdit',
          name: 'postEdit',
          component: () => import('@/view/forumCommunity/post/Edit.vue'),
        },
        {
          path: '/detailCreate',
          name: 'detailCreate',
          component: () => import('@/view/forumCommunity/post/Detail.vue'),
        },

        // { path: '/trainingAndStudy', name: 'trainingAndStudy', component: trainingAndStudy },

        {
          path: '/DistrictResourcesDetails',
          name: 'DistrictResourcesDetails',
          component: () => import('@/view/homepage/components/DistrictResourcesDetails.vue'),
        }, //首页
        {
          path: '/policyPaperDetails',
          name: 'policyPaperDetails',
          component: () => import('@/view/censusActivity/Details/policyPaperDetails.vue'),
        }, //普查动态-政策文件-详情
        {
          path: '/noticeDetails',
          name: 'noticeDetails',
          component: () => import('@/view/censusActivity/Details/noticeDetails.vue'),
        }, //普查动态-通知公告-详情
        {
          path: '/trainingCourseDetails',
          name: 'trainingCourseDetails',
          component: () => import('@/view/censusActivity/Details/trainingCourseDetails.vue'),
        }, //普查动态-培训学习-详情
        {
          path: '/newPage',
          name: 'newPage',
          component: () => import('@/view/newPage/newPage.vue'),
        }, //iframe嵌套页面

        {
          path: '/3DRealityDetails',
          name: '3DRealityDetails',
          component: () => import('@/view/ThreeDimensionalReality/3DRealityDetails.vue'),
        }, //三维实景-详情
      ],
    }, //设置当为空的时候，自动跳转到登录页面；
    {
      path: '/Login',
      name: 'Login',
      component: () => import('@/view/user/Login.vue'),
    }, //登录；
    {
      path: '/Register',
      name: 'Register',
      component: () => import('@/view/regist/regist.vue'),
    }, //注册；
    {
      path: '/model3d',
      name: 'model3d',
      component: () => import('@/view/model3d/model3d.vue'),
    }, //三维实景-详情
  ],
});

router.beforeEach(async (to, from, next) => {
  if (Cookies.get('accessToken') && Cookies.get('accessToken').length) {
    userInfo().then((res) => {
      if (res.success === true) {
        delete res.result.permissions;
        let roles = [];
        res.result.roles.forEach((e) => {
          roles.push(e.name);
        });
        Cookies.set('roles', JSON.stringify(roles), {
          expires: 7,
        });
        setStore('roles', roles);
        setStore('accessToken', Cookies.get('accessToken'));
        setStore('userInfo', JSON.stringify(res.result));
        // 保存7天
        Cookies.set('userInfo', JSON.stringify(res.result), {
          expires: 7,
        });
        // 保存7天
        Cookies.set('username', res.result.username, {
          expires: 7,
        });
        Cookies.set('autoLogin', 'true', {
          expires: 7,
        });
      }
    });
    if (to.name == 'Login') {
      next('/');
    } else {
      next();
    }
  }
  if (Cookies.get('locking') === '1' && to.name !== 'locking') {
    // 判断当前是否是锁定状态
    next({
      replace: true,
      name: 'locking',
    });
  } else {
    next();
  }
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js